import { Select } from "antd"
import { useEffect, useState } from 'react';
import { getActorTypes } from "../../../../controllers/entities";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { getCapacitiesType } from "../../../../controllers/capacities";

interface Props  {
    onChange: (value : any) => void,
    size? : SizeType,
    defaultValue? : string,
    style? : any
}

const SelectCapacitiesType = (props: Props) => {
    const [capacities, setCapacitiesTypes] = useState([]);
    useEffect(() => {
        const get_capacities_types = async () => {
            const capacitiesData = await getCapacitiesType();
            setCapacitiesTypes(capacitiesData.map((capacity: any) => {
                return {
                    value: capacity.id,
                    label: capacity.capacities,
                    collectionName : capacity.collection_name
                }
            }));
        }
        get_capacities_types();
    }, []);
    
    return (
        <div style={{width : '100%'}}>
            <Select
                {...props}
                allowClear
                labelInValue
                size={props.size}
                defaultValue={props?.defaultValue || ''}
                style={props.style}
                onChange={(selected:any) => {
                    if (selected) {
                        const value = capacities.find((capacacity: any) => capacacity.value === selected.value);
                        props.onChange(value);
                    }
                }}
                options={capacities}
            />        
        </div>
    );
}

export default SelectCapacitiesType